import API from '../api-service.js';
import content from '@/utils/shared/content-structure';

const baseUri = 'content/ots';

export default {
  getContent(params) {
    return API.get(baseUri, params).then(res => {
      return {
        total: res.meta.page.total,
        cursor: res.meta.page.cursor,
        content: res.data.content.map(item => content.mapContent(item)),
        facets: res.data.facets,
      };
    });
  },
  getContentExportUrl(params) {
    return API.get(`${baseUri}/export`, params).then(res => res);
  },
  getProfile(syncguid) {
    return API.get(`${baseUri}/${syncguid}`).then(res => {
      return content.mapContent(res);
    });
  },
  getThumbnail(syncguid) {
    return API.get(`${baseUri}/${syncguid}/image/poster`).then(res => res);
  },
  downloadThumbnail(syncguid, file) {
    return API.get(`${baseUri}/${syncguid}/image/poster/download`, {
      title: file,
    }).then(res => {
      window.open(res, '_blank');
    });
  },
  getSupportMaterials(syncguid) {
    return API.get(`${baseUri}/${syncguid}/materials`).then(res => res);
  },
  getInteractions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/interactions`).then(
      res => res.material,
    );
  },
  getResources(syncguid) {
    return API.get(`${baseUri}/${syncguid}/resources`).then(res => res);
  },
  getCaptions(syncguid) {
    return API.get(`${baseUri}/${syncguid}/captions`).then(res =>
      res.material && res.material[0] ? res.material[0].data : [],
    );
  },
  getSuggestedAlternatives(syncguid) {
    return API.get(`${baseUri}/${syncguid}/alternatives`).then(res => res);
  },
  downloadSupportMaterial(syncguid, file) {
    return API.get(`${baseUri}/${syncguid}/materials/${file}`).then(res => {
      window.open(res, '_blank');
    });
  },
  getCourseXML(syncguid) {
    return API.get(`${baseUri}/${syncguid}/coursexml`);
  },
  getQuiz(syncguid) {
    return API.get(`${baseUri}/${syncguid}/quiz`);
  },
};
